import { render, staticRenderFns } from "./account-forgot-password.vue?vue&type=template&id=2181e300&scoped=true&"
import script from "./account-forgot-password.vue?vue&type=script&lang=js&"
export * from "./account-forgot-password.vue?vue&type=script&lang=js&"
import style0 from "./account-forgot-password.vue?vue&type=style&index=0&id=2181e300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181e300",
  null
  
)

export default component.exports